export const HalfScreenIcon = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="102"
      height="102"
      viewBox="0 0 102 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_b_1810_2059)">
        <rect
          width="102"
          height="102"
          rx="12.5446"
          fill="white"
          fillOpacity="0.1"
        />
        <g clipPath="url(#clip0_1810_2059)">
          <path
            d="M48.0832 24.7495H27.6578C26.4987 24.7511 25.3877 25.2128 24.569 26.0332C23.7502 26.8536 23.2907 27.9655 23.2915 29.1245V72.8745C23.2915 75.2939 25.2442 77.2495 27.6578 77.2495H48.0832V84.5368C48.0832 84.9236 48.2368 85.2945 48.5103 85.568C48.7838 85.8415 49.1547 85.9952 49.5415 85.9952C49.9283 85.9952 50.2992 85.8415 50.5727 85.568C50.8462 85.2945 50.9998 84.9236 50.9998 84.5368V17.4622C50.9998 17.0755 50.8462 16.7045 50.5727 16.431C50.2992 16.1576 49.9283 16.0039 49.5415 16.0039C49.1547 16.0039 48.7838 16.1576 48.5103 16.431C48.2368 16.7045 48.0832 17.0755 48.0832 17.4622V24.7495ZM58.2915 27.6662C57.9047 27.6662 57.5338 27.5126 57.2603 27.2391C56.9868 26.9656 56.8332 26.5946 56.8332 26.2079C56.8332 25.8211 56.9868 25.4502 57.2603 25.1767C57.5338 24.9032 57.9047 24.7495 58.2915 24.7495H74.3288C74.9037 24.749 75.4731 24.8617 76.0044 25.0813C76.5357 25.3009 77.0185 25.6231 77.4252 26.0294C77.8319 26.4357 78.1546 26.9182 78.3747 27.4493C78.5949 27.9804 78.7082 28.5496 78.7082 29.1245V72.8745C78.7082 73.4494 78.5949 74.0187 78.3747 74.5498C78.1546 75.0809 77.8319 75.5634 77.4252 75.9697C77.0185 76.376 76.5357 76.6982 76.0044 76.9178C75.4731 77.1374 74.9037 77.2501 74.3288 77.2495H58.2915C57.9047 77.2495 57.5338 77.0959 57.2603 76.8224C56.9868 76.5489 56.8332 76.178 56.8332 75.7912C56.8332 75.4044 56.9868 75.0335 57.2603 74.76C57.5338 74.4865 57.9047 74.3329 58.2915 74.3329H74.3288C74.5207 74.3334 74.7108 74.2962 74.8882 74.2231C75.0657 74.1501 75.2269 74.0428 75.3628 73.9073C75.4987 73.7718 75.6065 73.6108 75.6801 73.4336C75.7536 73.2564 75.7915 73.0664 75.7915 72.8745V29.1245C75.7915 28.9327 75.7536 28.7427 75.6801 28.5654C75.6065 28.3882 75.4987 28.2273 75.3628 28.0918C75.2269 27.9563 75.0657 27.849 74.8882 27.7759C74.7108 27.7029 74.5207 27.6656 74.3288 27.6662H58.2915Z"
            fill="white"
          />
        </g>
        <rect
          x="0.418153"
          y="0.418153"
          width="101.164"
          height="101.164"
          rx="12.1264"
          stroke="url(#paint0_linear_1810_2059)"
          strokeWidth="0.836306"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_1810_2059"
          x="-21.744"
          y="-21.744"
          width="145.488"
          height="145.488"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="10.872" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1810_2059"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1810_2059"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1810_2059"
          x1="9.12934"
          y1="-9.36905e-07"
          x2="55.009"
          y2="61.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_1810_2059">
          <rect
            width="70"
            height="70"
            fill="white"
            transform="translate(16 16)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
